<template>
  <div class="notice">
        <div class="screen-box">
          <a-form layout="inline" @submit="handleSubmit">
            <a-form-item>
              <a-select class="select-item" placeholder="选择公司" v-model="form.selectCompany">
                <a-select-option v-for="item in companyArr" :key="item.id" :value="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="日期：">
              <a-range-picker class="date-picker" v-model="form.selectDate" @change="onChangeDate" />
            </a-form-item>
            <a-form-item label="搜索：">
              <a-input v-model="form.selectMember" placeholder="请输入关键字搜索" />
            </a-form-item>
            <a-form-item>
              <a-button html-type="submit" shape="circle" icon="search"></a-button>
            </a-form-item>

            <a-form-item>
              <a-button @click="clearSelect">
                重置
              </a-button>
            </a-form-item>
          </a-form>
        </div>
        <Table ref="screentable" :request="api.systemGetLists" :columns="columnsscreens" :param="{ pageSize: 10,company_id:form.selectCompany,keywords:form.selectMember,start_time:form.selectDate[0]?form.selectDate[0]:'',end_time:form.selectDate[1]?form.selectDate[1]:''}">
          <img class="img" slot="avatar" slot-scope="scope" :src="scope.text.user_info.avatar">
          <span slot="company" slot-scope="scope">{{scope.text.user_company.name}}</span>
          <span slot="role" slot-scope="scope">{{scope.text.user_role.name?scope.text.user_role.name:''}}</span>
          <span slot="user" slot-scope="scope">{{scope.text.user_info.name}}</span>
          <span slot="behavior" slot-scope="scope">{{scope.text.behavior==1?'加入空间':scope.text.behavior==2?'移除空间':'关联成功'}}</span>
        </Table>
  </div>
</template>

<script>
import Table from '../../components/table.vue'
export default {
  components: {
    Table
  },
  data() {
    return {
      companyArr: [],
      form: {
        selectCompany: [], // 筛选条件-公司
        selectMember: '', // 筛选条件-成员
        selectDate: [], // 筛选条件-日期
      },
      columnsscreens:[
        {
          title: '头像',
          key: 'avatar',
          // dataIndex: 'image_url',
          scopedSlots: { customRender: 'avatar' },
          width: '200',
        },
        {
          title: '公司',
          key: 'company',
          // dataIndex: 'updated_at',
          scopedSlots: { customRender: 'company' },
          width: '200',
        },
        {
          title: '角色',
          key: 'role',
          // dataIndex: 'user',
          scopedSlots: { customRender: 'role' },
          width: '200',
        },
        {
          title: '用户',
          key: 'user',
          // dataIndex: 'user',
          scopedSlots: { customRender: 'user' },
          width: '200',
        },
        {
          title: '操作',
          key: 'behavior',
          // dataIndex: 'font_company',
          scopedSlots: { customRender: 'behavior' },
          width: '200',
        },
        {
          title: '时间',
          // key: 'uplatetime',
          dataIndex: 'created_at',
          // scopedSlots: { customRender: 'uplatetime' },
          width: '100',
          sorter:true
        }
      ],
    };
  },
  methods: {
    // 重置
    clearSelect() {
      this.form.selectCompany = []
      this.form.selectMember = ''
      this.form.selectDate = []
      setTimeout(() => {
        this.$refs.screentable.getData()
      }, 10);
    },
    onChangeDate(date, dateString) {
      this.form.selectDate = dateString
    },
    handleSubmit() {
      this.$refs.screentable.getData()
    },
    // 获取公司列表
    getCompanyList() {
      console.log(66,JSON.parse(window.localStorage.getItem('userInfo')))
      // 公司列表
      this.api.contractorLists({
        company_id:JSON.parse(window.localStorage.getItem('userInfo')).company_id
      }).then(res => {
        if(res.code==0){
          
          let arr = []
          res.data.lists&&res.data.lists.map((v)=>{
            arr.push(v.contractor)
          })
          this.companyArr = arr
        }
      })
    }
  },
  created() {
    this.getCompanyList()
  }
}
</script>

<style scoped>
.notice {
  background-color: #ffffff;
  border-radius: 10px;
  padding: 40px;
}

.screen-box {
  padding: 0 0 16px 0;
  border-bottom: 1px solid rgba(0, 0, 0, .1);
}

.select-item {
  width: 130px;
}

.date-picker {
  width: 260px;
}

.img {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 50%;
}
</style>